import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import { Row, Col, Card, Container } from "react-bootstrap";

const baseURL = process.env.REACT_APP_API_JOBS;

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const Add = ({ mekhraz_id, SetIsAdded }) => {
  const axiosPrivate = useAxiosPrivate();
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [error, setError] = useState(false);
  const toDay = new Date();
  const dateS =
    toDay.getFullYear() +
    "-" +
    ("0" + (toDay.getMonth() + 1)).substr(-2) +
    "-" +
    ("0" + toDay.getDate()).substr(-2);
  const timeS =
    ("0" + toDay.getHours()).substr(-2) +
    ":" +
    ("0" + toDay.getMinutes()).substr(-2);

  const [inputField, setInputField] = useState({
    date: dateS,
    time: timeS,
    mozmaneem_num: 8,
    persoom: true,
    nemmok_ei_persoom: "",
    tsion_saf: 0,
    natseeg_rosh_harashoot: "",
    memona_mashaavi_enosh: "",
    yoamash: "",
    notes: "",
    mekhraz: mekhraz_id,
  });
  const [dateValue, onChangeDate] = useState(inputField.date);
  const [reasonIsRequired, setReasonIsRequired] = useState(true);
  // handle change event
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "persoom") {
      inputField.persoom = e.target.checked;
      setReasonIsRequired((prev) => !prev);
    } else {
      setInputField((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "myonmakdeem/",
          inputField,
          {
            signal: controller.signal,
          }
        );
        alert("פרטי הישיבה עודכנו");
        //isMounted &&
        SetIsAdded((prev) => !prev);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    if (!inputField.persoom && inputField.nemmok_ei_persoom == "") {
      alert(
        "לא ניתן לעדכן את הישיבה, חובה לספק סיבת אי פירסום אמות המידה של שלב המיון המקדים."
      );
    } else {
      postData();
      //setTitle("");
      setError(false);
    }
  };

  return (
    <>
      <HelpModal />
      <Card className="success container px-5 " bg="light">
        <Card.Header className="mx-auto">
          <h3
            onClick={() => {
              setSaeef("25");
              setShowHelp(true);
            }}
          >
            הוספת מיון מקדים
            <span className="help">
              <MdLiveHelp />
            </span>
          </h3>
        </Card.Header>
        <Card.Body>
          <form onSubmit={handleSubmit}>
            <Container className="col-sm-10">
              <Row>
                <Col>
                  <label htmlFor="date">תאריך עריכת הישיבה </label>
                  <input
                    type="date"
                    name="date"
                    value={inputField.date}
                    onChange={handleChange}
                    className="form-control"
                    id="date"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="time">זמן עריכת הישיבה </label>
                  <input
                    type="time"
                    name="time"
                    value={inputField.time}
                    onChange={handleChange}
                    className="form-control"
                    id="time"
                    placeholder=""
                  />
                </Col>

                <Col>
                  <label htmlFor="mozmaneem_num">מספר המוזמנים </label>
                  <input
                    type="number"
                    min="8"
                    name="mozmaneem_num"
                    value={inputField.mozmaneem_num}
                    onChange={handleChange}
                    className="form-control"
                    id="mozmaneem_num"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="tsion_saf">ציון סף</label>
                  <input
                    type="number"
                    name="tsion_saf"
                    value={inputField.tsion_saf}
                    onChange={handleChange}
                    className="form-control"
                    id="tsion_saf"
                    placeholder="ציון הסף לבחינת המועמד"
                  />
                </Col>
              </Row>
              <Row>
                {" "}
                <Col>
                  <label htmlFor="natseeg_rosh_harashoot">
                    נציג ראש הרשות{" "}
                  </label>
                  <input
                    type="text"
                    name="natseeg_rosh_harashoot"
                    value={inputField.natseeg_rosh_harashoot}
                    onChange={handleChange}
                    className="form-control"
                    id="natseeg_rosh_harashoot"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="memona_mashaavi_enosh">
                    {" "}
                    ממונה משאבי אנוש
                  </label>
                  <input
                    type="text"
                    name="memona_mashaavi_enosh"
                    value={inputField.memona_mashaavi_enosh}
                    onChange={handleChange}
                    className="form-control"
                    id="memona_mashaavi_enosh"
                    placeholder=""
                  />
                </Col>
                <Col>
                  <label htmlFor="yoamash"> היועץ המשפטי </label>
                  <input
                    type="text"
                    name="yoamash"
                    value={inputField.yoamash}
                    onChange={handleChange}
                    className="form-control"
                    id="yoamash"
                    placeholder=""
                  />
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col className="d-flex justify-content-center">
                  <div className="form-group col-sm-6">
                    <label htmlFor="persoom">
                      האם פרטי המיון המקדים פורסמו ?
                    </label>
                    <input
                      type="checkbox"
                      id="persoom"
                      name="persoom"
                      defaultChecked={inputField.persoom}
                      onChange={handleChange}
                    />
                    <br />
                    {!reasonIsRequired &&
                      "שים לב חייב לספק נימוקים לאי פרסום פרטי המיון המקדים."}
                  </div>
                </Col>
                <Col>
                  <label htmlFor="nemmok_ei_persoom">
                    {" "}
                    נימוקים לאי פירסום פרטי המיון המקדים{" "}
                  </label>
                  <textarea
                    style={{
                      width: "100%",
                      maxWidth: "500px",
                      padding: "0px",
                      margin: "5px",
                    }}
                    name="nemmok_ei_persoom"
                    value={inputField.nemmok_ei_persoom}
                    onChange={handleChange}
                    className="form-control"
                    id="nemmok_ei_persoom"
                    placeholder=""
                    required={inputField.persoom.checked}
                    cols="60"
                    rows="10"
                  />
                </Col>
              </Row>
              <div className="d-flex justify-content-center">
                <button type="submit" className="btn btn-primary">
                  שמור
                </button>
              </div>
            </Container>
          </form>
        </Card.Body>
      </Card>
    </>
  );
};

export default Add;
